"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _SegmentIntersector = _interopRequireDefault(require("./SegmentIntersector"));

var _ArrayList = _interopRequireDefault(require("../../../../java/util/ArrayList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var InteriorIntersectionFinder =
/*#__PURE__*/
function () {
  function InteriorIntersectionFinder() {
    _classCallCheck(this, InteriorIntersectionFinder);

    InteriorIntersectionFinder.constructor_.apply(this, arguments);
  }

  _createClass(InteriorIntersectionFinder, [{
    key: "getInteriorIntersection",
    value: function getInteriorIntersection() {
      return this._interiorIntersection;
    }
  }, {
    key: "setCheckEndSegmentsOnly",
    value: function setCheckEndSegmentsOnly(isCheckEndSegmentsOnly) {
      this._isCheckEndSegmentsOnly = isCheckEndSegmentsOnly;
    }
  }, {
    key: "getIntersectionSegments",
    value: function getIntersectionSegments() {
      return this._intSegments;
    }
  }, {
    key: "count",
    value: function count() {
      return this._intersectionCount;
    }
  }, {
    key: "getIntersections",
    value: function getIntersections() {
      return this._intersections;
    }
  }, {
    key: "setFindAllIntersections",
    value: function setFindAllIntersections(findAllIntersections) {
      this._findAllIntersections = findAllIntersections;
    }
  }, {
    key: "setKeepIntersections",
    value: function setKeepIntersections(keepIntersections) {
      this._keepIntersections = keepIntersections;
    }
  }, {
    key: "processIntersections",
    value: function processIntersections(e0, segIndex0, e1, segIndex1) {
      if (!this._findAllIntersections && this.hasIntersection()) return null;
      if (e0 === e1 && segIndex0 === segIndex1) return null;

      if (this._isCheckEndSegmentsOnly) {
        var isEndSegPresent = this.isEndSegment(e0, segIndex0) || this.isEndSegment(e1, segIndex1);
        if (!isEndSegPresent) return null;
      }

      var p00 = e0.getCoordinates()[segIndex0];
      var p01 = e0.getCoordinates()[segIndex0 + 1];
      var p10 = e1.getCoordinates()[segIndex1];
      var p11 = e1.getCoordinates()[segIndex1 + 1];

      this._li.computeIntersection(p00, p01, p10, p11);

      if (this._li.hasIntersection()) {
        if (this._li.isInteriorIntersection()) {
          this._intSegments = new Array(4).fill(null);
          this._intSegments[0] = p00;
          this._intSegments[1] = p01;
          this._intSegments[2] = p10;
          this._intSegments[3] = p11;
          this._interiorIntersection = this._li.getIntersection(0);
          if (this._keepIntersections) this._intersections.add(this._interiorIntersection);
          this._intersectionCount++;
        }
      }
    }
  }, {
    key: "isEndSegment",
    value: function isEndSegment(segStr, index) {
      if (index === 0) return true;
      if (index >= segStr.size() - 2) return true;
      return false;
    }
  }, {
    key: "hasIntersection",
    value: function hasIntersection() {
      return this._interiorIntersection !== null;
    }
  }, {
    key: "isDone",
    value: function isDone() {
      if (this._findAllIntersections) return false;
      return this._interiorIntersection !== null;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return InteriorIntersectionFinder;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_SegmentIntersector.default];
    }
  }], [{
    key: "createAllIntersectionsFinder",
    value: function createAllIntersectionsFinder(li) {
      var finder = new InteriorIntersectionFinder(li);
      finder.setFindAllIntersections(true);
      return finder;
    }
  }, {
    key: "createAnyIntersectionFinder",
    value: function createAnyIntersectionFinder(li) {
      return new InteriorIntersectionFinder(li);
    }
  }, {
    key: "createIntersectionCounter",
    value: function createIntersectionCounter(li) {
      var finder = new InteriorIntersectionFinder(li);
      finder.setFindAllIntersections(true);
      finder.setKeepIntersections(false);
      return finder;
    }
  }]);

  return InteriorIntersectionFinder;
}();

exports.default = InteriorIntersectionFinder;

InteriorIntersectionFinder.constructor_ = function () {
  this._findAllIntersections = false;
  this._isCheckEndSegmentsOnly = false;
  this._li = null;
  this._interiorIntersection = null;
  this._intSegments = null;
  this._intersections = new _ArrayList.default();
  this._intersectionCount = 0;
  this._keepIntersections = true;
  var li = arguments[0];
  this._li = li;
  this._interiorIntersection = null;
};